import React from 'react';
import { ChainTabs, VaultPreviews } from '@components';

export const VaultsPage = () => (
  <>
    <ChainTabs mb={3} />
    <VaultPreviews />
  </>
);
